import axios from "axios";
import store from "../store";
import { authActions } from "../store/auth";
import { grnActions } from "../store/grn";
import { getSSOToken, logoutSSO } from "../utils/ssoHelper";

const DEFAULT_CONFIG = {
  headers: {
    "content-type": "application/json",
  },
};

const setUpConfig = (isAuthenticated, token = "") => {
  if (isAuthenticated) {
    return {
      headers: {
        "content-type": "application/json",
        authorization: token ? token : localStorage.getItem("user_token"),
      },
    };
  } else {
    return DEFAULT_CONFIG;
  }
};

const get = async (URL, isAuthenticated = false, getFullResult = false) => {
  try {
    const CONFIG = setUpConfig(isAuthenticated);
    const result = await axios.get(URL, CONFIG);
    if (getFullResult) {
      return result?.data?.body;
    } else {
      return result.data;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
};

const post = async (
  URL,
  PAYLOAD = {},
  isAuthenticated = false,
  getFullResult = false
) => {
  try {
    store.dispatch(grnActions.updateLambdaErr(false));

    const TOKEN = store.getState()?.auth?.token;
    const CONFIG = setUpConfig(isAuthenticated, TOKEN);


    const result = await axios.post(URL, PAYLOAD, CONFIG);

    if (result?.data?.status === "invalid") {
      store.dispatch(authActions.clearAuth());
      await logoutSSO();
      return false;
    }

    return getFullResult ? result?.data?.body : result?.data;
  } catch (e) {
    const status = e?.response?.status;
    console.log("eee", e)

    if (status === 401 && isAuthenticated) {
      try {
        const newTokenData = await getSSOToken();

        if (newTokenData?.token) {
          localStorage.setItem("user_token", newTokenData.token);

          const currentUser = store.getState()?.auth?.user || {};

          store.dispatch(
            authActions.setSSOLogin({
              token: newTokenData.token,
              user:
                newTokenData.user || {
                  ...currentUser,
                  permissions: {
                    roles: currentUser.roleList || [],
                  },
                },
            })
          );

          const retryConfig = setUpConfig(true, newTokenData.token);
          const retryResult = await axios.post(URL, PAYLOAD, retryConfig);

          if (retryResult?.data?.status === "invalid") {
            store.dispatch(authActions.clearAuth());
            await logoutSSO();
            return false;
          }

          return getFullResult
            ? retryResult?.data?.body
            : retryResult?.data;
        }

        store.dispatch(authActions.clearAuth());
        await logoutSSO();
        return false;
      } catch (refreshErr) {
        console.log("SSO refresh failed:", refreshErr);
        store.dispatch(authActions.clearAuth());
        await logoutSSO();
        return false;
      }
    }

    store.dispatch(grnActions.updateLambdaErr(true));
    return false;
  }
};

export const tokenExpiry = (status) => {
  return !(status === "error" || status === "success" || status === "validation_error" || status === "invalid");
};


export { post, get };
